import { generatePath, NavigateOptions, useNavigate, useParams } from "react-router-dom";
import routes from "@/constants/routes";
import get from "lodash/get";
import { useAppSelector } from ".";

const useRoutes = () => {
  const navigate = useNavigate();
  const { organizationAlias } = useParams();
  const organizationId = useAppSelector((state) => state.ui.activeOrganization);

  const getUrl = (url: string, params: Record<string, string> = {}, includeQueryStrings = true): string => {
    const _params = { ...params };
    const _url = get(routes, url, "");

    const requiresOrganizationId = _url.includes(":organizationId");
    const requiresOrganizationAlias = _url.includes(":organizationAlias");

    if (requiresOrganizationId && organizationId && !_params.organizationId) {
      _params.organizationId = organizationId;
    }

    if (requiresOrganizationAlias && organizationAlias && !_params.organizationAlias) {
      _params.organizationAlias = organizationAlias;
    }

    if (includeQueryStrings) {
      return generatePath(_url, _params) + document.location.search;
    }

    return generatePath(_url, _params);
  };

  const goToUrl = (
    url: string,
    params: Record<string, string>
      = {},
    options: NavigateOptions = {}
  ) => {

    if (url.startsWith("/")) {
      navigate(url, options);
      return;
    }

    const finalPath = getUrl(url, params, false);
    navigate(finalPath, options)

  };

  return [goToUrl, getUrl];
};

export default useRoutes;
